import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/apiClient';
import { CarritoConPrecios } from '../types/carrito';
import { obtenerCartSessionId } from '../storage/cartSessionStorage';

/**
 * NFR Design, Pregunta 2: sin actualizaciones optimistas — se espera la
 * confirmación del servidor antes de reflejar el cambio en la UI.
 */
export function useCarrito() {
  const sessionId = obtenerCartSessionId();
  return useQuery({
    queryKey: ['carrito', sessionId],
    queryFn: () => apiFetch<CarritoConPrecios>(`/carrito/${sessionId}`),
  });
}

export function useAgregarAlCarrito() {
  const queryClient = useQueryClient();
  const sessionId = obtenerCartSessionId();
  return useMutation({
    mutationFn: (datos: { productoId: string; paqueteId: string; cantidadDePaquetes: number }) =>
      apiFetch(`/carrito/${sessionId}/items`, { method: 'POST', body: datos }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['carrito', sessionId] }),
  });
}

export function useActualizarItemCarrito() {
  const queryClient = useQueryClient();
  const sessionId = obtenerCartSessionId();
  return useMutation({
    mutationFn: ({ lineaId, cantidadDePaquetes }: { lineaId: string; cantidadDePaquetes: number }) =>
      apiFetch(`/carrito/${sessionId}/items/${lineaId}`, {
        method: 'PUT',
        body: { cantidadDePaquetes },
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['carrito', sessionId] }),
  });
}

export function useEliminarItemCarrito() {
  const queryClient = useQueryClient();
  const sessionId = obtenerCartSessionId();
  return useMutation({
    mutationFn: (lineaId: string) =>
      apiFetch(`/carrito/${sessionId}/items/${lineaId}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['carrito', sessionId] }),
  });
}
